
interface EmailNotificationData {
  type: 'confirmation' | 'cancellation' | 'reschedule' | 'reminder';
  patientEmail: string;
  patientName: string;
  providerName: string;
  appointmentDate: string;
  appointmentTime: string;
  bookingId: string;
  reason?: string;
  previousDate?: string;
  previousTime?: string;
}

export const sendEmailNotification = async (data: EmailNotificationData): Promise<boolean> => {
  console.log('Sending email notification:', data);
  
  // Simulate email sending - in a real app, this would call your email service
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log(`${data.type} email sent to ${data.patientEmail}`);
      resolve(true);
    }, 1000);
  });
};

export const sendRescheduleNotification = async (
  bookingId: string,
  patientEmail: string,
  patientName: string,
  providerName: string,
  newDate: string,
  newTime: string,
  previousDate: string,
  previousTime: string
): Promise<boolean> => {
  return sendEmailNotification({
    type: 'reschedule',
    patientEmail,
    patientName,
    providerName,
    appointmentDate: newDate,
    appointmentTime: newTime,
    bookingId,
    previousDate,
    previousTime
  });
};

export const sendCancellationNotification = async (
  bookingId: string,
  patientEmail: string,
  patientName: string,
  providerName: string,
  appointmentDate: string,
  appointmentTime: string
): Promise<boolean> => {
  return sendEmailNotification({
    type: 'cancellation',
    patientEmail,
    patientName,
    providerName,
    appointmentDate,
    appointmentTime,
    bookingId
  });
};

export const getEmailTemplate = (data: EmailNotificationData): string => {
  const { type, patientName, providerName, appointmentDate, appointmentTime, bookingId } = data;
  
  switch (type) {
    case 'confirmation':
      return `
        <h2>Appointment Confirmed</h2>
        <p>Dear ${patientName},</p>
        <p>Your appointment has been confirmed with the following details:</p>
        <ul>
          <li><strong>Provider:</strong> ${providerName}</li>
          <li><strong>Date:</strong> ${appointmentDate}</li>
          <li><strong>Time:</strong> ${appointmentTime}</li>
          <li><strong>Booking ID:</strong> ${bookingId}</li>
        </ul>
        <p>Please arrive 15 minutes early and bring a valid ID and insurance card.</p>
      `;
      
    case 'cancellation':
      return `
        <h2>Appointment Cancelled</h2>
        <p>Dear ${patientName},</p>
        <p>Your appointment with ${providerName} on ${appointmentDate} at ${appointmentTime} has been cancelled.</p>
        <p>Booking ID: ${bookingId}</p>
        <p>If you need to schedule a new appointment, please contact us.</p>
      `;
      
    case 'reschedule':
      return `
        <h2>Appointment Rescheduled</h2>
        <p>Dear ${patientName},</p>
        <p>Your appointment has been rescheduled:</p>
        <ul>
          <li><strong>Previous:</strong> ${data.previousDate} at ${data.previousTime}</li>
          <li><strong>New Date:</strong> ${appointmentDate}</li>
          <li><strong>New Time:</strong> ${appointmentTime}</li>
          <li><strong>Provider:</strong> ${providerName}</li>
          <li><strong>Booking ID:</strong> ${bookingId}</li>
        </ul>
        <p>Please arrive 15 minutes early and bring a valid ID and insurance card.</p>
      `;
      
    case 'reminder':
      return `
        <h2>Appointment Reminder</h2>
        <p>Dear ${patientName},</p>
        <p>This is a reminder of your upcoming appointment:</p>
        <ul>
          <li><strong>Provider:</strong> ${providerName}</li>
          <li><strong>Date:</strong> ${appointmentDate}</li>
          <li><strong>Time:</strong> ${appointmentTime}</li>
          <li><strong>Booking ID:</strong> ${bookingId}</li>
        </ul>
        <p>Please arrive 15 minutes early.</p>
      `;
      
    default:
      return '';
  }
};
